/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Hub_HintInputs */

const en_us2_gallery_hub_hint = /** @type {(inputs: Gallery_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans the community shared, reviewed by the team`)
};

const pt_br2_gallery_hub_hint = /** @type {(inputs: Gallery_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planos que a comunidade compartilhou, revisados pela equipe`)
};

const pt_pt2_gallery_hub_hint = /** @type {(inputs: Gallery_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planos que a comunidade compartilhou, revisados pela equipe`)
};

/** @type {(inputs: Gallery_Hub_HintInputs) => LocalizedString} */
const es_419_gallery_hub_hint = en_us2_gallery_hub_hint;

/** @type {(inputs: Gallery_Hub_HintInputs) => LocalizedString} */
const fr_fr2_gallery_hub_hint = en_us2_gallery_hub_hint;

/** @type {(inputs: Gallery_Hub_HintInputs) => LocalizedString} */
const de_de2_gallery_hub_hint = en_us2_gallery_hub_hint;

/** @type {(inputs: Gallery_Hub_HintInputs) => LocalizedString} */
const it_it2_gallery_hub_hint = en_us2_gallery_hub_hint;

/**
* | output |
* | --- |
* | "Plans the community shared, reviewed by the team" |
*
* @param {Gallery_Hub_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_hub_hint = /** @type {((inputs?: Gallery_Hub_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Hub_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_hub_hint(inputs)
	if (locale === "es-419") return es_419_gallery_hub_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_hub_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_hub_hint(inputs)
	if (locale === "de-DE") return de_de2_gallery_hub_hint(inputs)
	if (locale === "it-IT") return it_it2_gallery_hub_hint(inputs)
	return en_us2_gallery_hub_hint(inputs)
});
export { gallery_hub_hint as "gallery.hub_hint" }